import useRemotePagination from '@/shared/hooks/useRemotePagination';
import { LIQUIDATIONS_QUERY } from '@/shared/utils/lending';

export const useLiquidations = ({ loanId, idSs58 }: { loanId?: string; idSs58?: string }) => {
  const {
    isLoading: isLoadingLiquidations,
    data: liquidationsData,
    paginationControls,
  } = useRemotePagination(LIQUIDATIONS_QUERY, {
    context: { clientName: 'lpProcessor' },
    paginationLimits: [10, 20, 40, 60, 80, 100],
    initialLimit: 10,
    refetchInterval: 6_000,
    variables: { loanId: loanId || undefined, idSs58: idSs58 || undefined },
  });

  return {
    isLoadingLiquidations,
    liquidationsData,
    paginationControls,
  };
};
